module.exports = __webpack_public_path__ + "media/images/front/brands/creations/creations_3-633b6935a48aeb89f60f3b46793f7b93.jpg";